/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 17:26:16
 * @LastEditTime: 2020-11-19 17:30:17
 * @FilePath: \ensurance-front\src\router\modules\system-settings.js
 */
const SystemSettings = () => import('@/views/system-settings/system-settings.vue')
const UserManage = () => import('@/views/system-settings/user-manage/user-manage.vue')
const AccountManage = () => import('@/views/system-settings/account-manage/account-manage.vue')
const OperationRecord = () => import('@/views/system-settings/operation-record/operation-record.vue')

export default [
  {
    path: '/systemSettings',
    name: 'SystemSettings',
    component: SystemSettings,
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: '/systemSettings/user_manage',
        name: 'UserManage',
        component: UserManage,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/systemSettings/account_manage',
        name: 'AccountManage',
        component: AccountManage,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/systemSettings/operation_record',
        name: 'OperationRecord',
        component: OperationRecord,
        meta: {
          keepAlive: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/system-settings.js